module.exports = __webpack_public_path__ + "img/invest_b2.63fa9e98.png";